/**
 * Renders the notification email recipients of an outbound RMA ticket as badges. Maps each address in the list to a badge item inside a badge list container.
 *
 * @param notificationEmail - Email addresses notified about the RMA ticket.
 * @returns Badge list element holding one badge per email address.
 */
const renderNotificationEmail = (notificationEmail: any) => (
  <div className="badge-email-list">
    {notificationEmail?.map((email: any) => (
      <div className="badge-email-item">{email}</div>
    ))}
  </div>
);

export { renderNotificationEmail };
